import { render, staticRenderFns } from "./QuestionUpload.vue?vue&type=template&id=372fcab4&"
import script from "./QuestionUpload.vue?vue&type=script&lang=js&"
export * from "./QuestionUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports